module.exports = __webpack_public_path__ + "img/servis-marketplace.645af3a2.svg";